import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-left-down-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { fill: "currentColor", d: "m6.75 11.5 1.75 2 1.75-2z" }),
        React.createElement("path", { d: "M8.5 13V7.5c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.837-1.334c.194-.031.426-.031.891-.031h0" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
